import { render, staticRenderFns } from "./BottomAction.vue?vue&type=template&id=7a4f952e&scoped=true"
import script from "./BottomAction.vue?vue&type=script&lang=js"
export * from "./BottomAction.vue?vue&type=script&lang=js"
import style0 from "./BottomAction.vue?vue&type=style&index=0&id=7a4f952e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f952e",
  null
  
)

export default component.exports